const getDetailsBanner = (state) => {
  return {
    title: state.bannerGenerator.title,
    description: state.bannerGenerator.description,
    titleButton: state.bannerGenerator.titleButton,
    colorButton: state.bannerGenerator.colorButton,
    logoBrand: state.bannerGenerator.logoBrand,
    imageBrand: state.bannerGenerator.imageBrand,
    backgroundColorDetailsArea: state.bannerGenerator.backgroundColorDetailsArea,
    borderRadiusButton: state.bannerGenerator.borderRadiusButton,
  };
};

export default {
  getDetailsBanner,
};
